import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: theme.palette.facet.primaryGray,
  },
  title: {
    marginRight: theme.spacing(1),
    whiteSpace: 'nowrap',
  },
});

const InlineDataField = ({
  className,
  classes,
  title,
  value,
}) => {
  if (!value) return null;

  return (
    <Box className={classNames(classes.root, className)}>
      <Typography className={classes.title} variant="body1">
        {title} {value}
      </Typography>
    </Box>
  );
};

InlineDataField.defaultProps = {
  className: '',
};

InlineDataField.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default withStyles(styles)(InlineDataField);
